export { IRSpectrum, ABSORBANCE, TRANSMITTANCE, getKind } from './IRSpectrum';
export { fromJcamp } from './from/jcamp';
export { fromText } from './from/text';
